import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PersonImage from "../Assests/kioskImage/Sec5_2img.png";
import PersonImage2 from "../Assests/kioskImage/Sec5_1img.png";
import "react-toastify/dist/ReactToastify.css";

const wellnessItems = [];
const appPlatforms = [];

const Fifth = () => {
  const [currentImage, setCurrentImage] = useState(PersonImage);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    preference: "",
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [wellnessCategories, setWellnessCategories] = useState(wellnessItems);
  const [selectedPlatforms, setSelectedPlatforms] = useState(appPlatforms);

  const handleOpen = () => {
    console.log("Modal opened or further action triggered");
  };

  useEffect(() => {
    const images = [PersonImage, PersonImage2];
    let index = 0;
    const intervalId = setInterval(() => {
      index = (index + 1) % images.length;
      setCurrentImage(images[index]);
    }, 2000);
    return () => clearInterval(intervalId);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setSuccess("");
    setLoading(true);

    const newErrors = {};
    if (!formData.name) {
      toast.error("Name is required.", {
        position: "top-center",
        autoClose: 2000,
        transition: Zoom,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
    if (!formData.email) {
      toast.error("Email is required.", {
        position: "top-center",
        autoClose: 2000,
        transition: Zoom,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        "https://f40aygafqj.execute-api.ap-south-1.amazonaws.com/dev/KioskRegister",
        formData
      );
      console.log(formData);

      if (response.status === 201) {
        toast.success(" Successfully registered!", {
          position: "top-center",
          autoClose: 2000,
          transition: Zoom,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setFormData({ name: "", email: "", preference: "" });
        setWellnessCategories(wellnessItems);
        setSelectedPlatforms(appPlatforms);
        handleOpen();
      }
    } catch (err) {
      const errorMsg = err.response?.data?.error || "Something went wrong.";
      setErrors({ server: errorMsg });

      toast.error(` ${errorMsg}`, {
        position: "top-center",
        autoClose: 2000,
        transition: Zoom,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Registration error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="query-background mb-20" id="button-navigate">
      <section className="query-form">
        <div className="form-container">
          <div className="form-content">
            <div className="form-image">
              <img
                src={currentImage}
                alt="Kiosk Usage"
                className="transition-image"
              />
            </div>
            <div className="form-fields-new">
              <p>For Kiosk Query</p>
              <p>Please enter the below details</p>
              <form onSubmit={handleSubmit}>
                <div className="input-group-query">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {errors.name && <p className="error">{errors.name}</p>}
                </div>
                <div className="input-group-query">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && <p className="error">{errors.email}</p>}
                </div>
                <p className="Choose-content">Choose your preference</p>
                <div className="checkbox-group mb-5">
                  <label>
                    <input
                      type="radio"
                      name="preference"
                      value="ayurvedic"
                      checked={formData.preference === "ayurvedic"}
                      onChange={handleChange}
                      style={{ width: "28px", height: "28px" }}
                    />
                    Ayurvedic Clinic
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="preference"
                      value="wellness"
                      checked={formData.preference === "wellness"}
                      onChange={handleChange}
                      style={{ width: "28px", height: "28px" }}
                    />
                    Wellness Centers
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="preference"
                      value="hospital"
                      checked={formData.preference === "hospital"}
                      onChange={handleChange}
                      style={{
                        width: "28px",
                        height: "28px",
                        backgroundColor: "#1c8686",
                      }}
                    />
                    Ayurveda Shop
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="preference"
                      value="others"
                      checked={formData.preference === "others"}
                      onChange={handleChange}
                      style={{
                        width: "28px",
                        height: "28px",
                        backgroundColor: "#1c8686",
                      }}
                    />
                    Others
                  </label>

                  {formData.preference === "others" && (
                    <div>
                      <input
                        type="text"
                        name="othersText"
                        placeholder="Enter your preference"
                        value={formData.othersText}
                        onChange={handleChange}
                        className="preference-input"
                      />
                    </div>
                  )}
                </div>
                <button
                  className="query-more-info-item-button"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit Enquiry"}
                </button>
              </form>
              {/* {success && <p className="success">{success}</p>}
              {errors.server && <p className="error">{errors.server}</p>} */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Fifth;
